import { useCallback, useEffect, useState } from 'react'

/**
 * Custom hook to calculate the grid unit size based on a CSS variable.
 * @returns The current grid unit size.
 */
const useGridUnit = () => {
  const [gridUnit, setGridUnit] = useState<number>(32)

  /**
   * Calculates the grid unit size based on the CSS variable.
   */
  const calculateGridUnit = useCallback(() => {
    const gridUnitValue = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--grid-unit')
    )
    if (isNaN(gridUnitValue) || gridUnitValue <= 0) {
      console.error('Invalid grid unit:', gridUnitValue)
      return
    }
    setGridUnit(gridUnitValue)
  }, [])

  useEffect(() => {
    calculateGridUnit()
    window.addEventListener('resize', calculateGridUnit)

    return () => {
      window.removeEventListener('resize', calculateGridUnit)
    }
  }, [calculateGridUnit])

  return gridUnit
}

export default useGridUnit
